<template>
  <router-view />
  <UniversalDialog
  
  ></UniversalDialog>
</template>

<script setup>
import UniversalDialog from "@internal_projects_dd/universal-dialog"
</script>